export default [
    {
        path: '/master/divisions',
        name: 'divisions',
        props: true,
        component: () => import('@/views/master/divisions/index.vue'),
        meta: {
            pageTitle: 'Divisions',
            breadcrumb: [
                {
                text: 'Divisions',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/divisions/add',
        name: 'create-divisions',
        component: () => import('@/views/master/divisions/create.vue'),
        meta: {
            pageTitle: 'Create Division',
            breadcrumb: [
                {
                text: 'Divisions',
                to: { name: 'divisions' },
                },
                {
                text: 'Create Division',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/divisions/:id',
        name: 'detail-divisions',
        props: true,
        component: () => import('@/views/master/divisions/detail.vue'),
        meta: {
            pageTitle: 'Detail Division',
            breadcrumb: [
                {
                text: 'Divisions',
                to: { name: 'divisions' },
                },
                {
                text: 'Detail Division',
                active: true,
                },
            ],
        },
    },
]